import { Box, Grid, Typography } from "@mui/material";
import oec from "@/assets/images/oec.svg";
import ListIcon from "@/assets/images/ListIcon.svg";

const cardLabels = [
  {
    text: "Oponernos a todo acto o actividad ilícita que detectemos y que pueda afectar a algunos de los actores de la cadena de suministro",
  },
  {
    text: "Estar alertas para evitar participar involuntariamente de manejos de mercaderías que atenten contra la seguridad.",
  },
  {
    text: "Cumplir con los requisitos legales y con las normativas nacionales e internacionales vigentes, que aplican a nuestras actividades.",
  },
  {
    text: "Colaborar en todo lo que esté a nuestro alcance para alcanzar un manejo seguro y legítimo de mercaderías.",
  },
  {
    text: "Sostener y mejorar continuamente nuestro Sistema de Gestión de la seguridad, manteniéndonos actualizados y capacitando a nuestra gente como modo de fomentar su participación activa.",
  },
  {
    text: "Disponer de los recursos necesarios para cumplir con esta política.",
  },
  {
    text: "Las actividades ilícitas asociadas al comercio exterior comprenden el narcotráfico, el contrabando, el terrorismo, el tráfico de productos falsificados, etc.",
  },
];

export const SecurityPolicy: React.FC = () => {
  return (
    <Box
      sx={{
        width: "calc(100vw - 4rem)",
        height: { xs: "fit-content", lg: "50rem" },
        margin: "6rem auto 0 auto",
        backgroundColor: "#4E8468",
        padding: "8rem 4rem 2rem 4rem",
        borderRadius: "14px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", lg: "start" },
          flexWrap: "wrap",
          gap: { xs: "1rem", lg: "1rem" },
        }}
      >
        <Typography
          variant="h2"
          color={"white"}
          fontSize={{ xs: "2.5rem", md: "3.7rem" }}
          fontWeight={700}
          maxWidth={"25rem"}
          textAlign={{ xs: "center", lg: "left" }}
        >
          Políticas de Seguridad
        </Typography>
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "50%",
            minWidth: "10rem",
            minHeight: "10rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "6px 6px 20px rgba(0, 0, 0, 0.2)",
          }}
        >
          <img src={oec} alt="oec" />
        </Box>
      </Box>
      <Grid
        container
        sx={{ marginTop: "1px", display: "flex", justifyContent: "center" }}
        spacing={5}
      >
        {cardLabels.map((item, index) => (
          <Grid key={index} item xs={12} lg={3} pb={4}>
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: "50%",
                boxShadow: "6px 6px 20px rgba(0, 0, 0, 0.2)",
                width: "3rem",
                height: "3rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "0.5rem",
              }}
            >
              <img src={ListIcon} alt="List Icon" />
            </Box>
            <Typography
              color={"white"}
              fontSize={"0.8rem"}
              fontFamily={"Montserrat"}
              fontWeight={500}
            >
              {item.text}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
